module.exports = __webpack_public_path__ + "img/77.da3386a.png";